import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';

import { MpsMockBaseService } from '@mps/mps-kit/mps-mock/services/mps-mock.service';

import { MpsMockInterceptor } from '@mps/mps-kit/mps-mock/interceptors/mps-mock-interceptor';
import { ZiikosFakerService } from './features/ziikos/services/ziikos-faker.service';
import { ZoumasFakerService } from './features/zoumas/services/zoumas-faker.service';

export function createMpsMockInterceptor(mockService: MpsMockBaseService<any>, count: number) {
  return new MpsMockInterceptor(mockService);
}

export const labConfig: ApplicationConfig = {
  providers: [
    { provide: HTTP_INTERCEPTORS, useFactory: createMpsMockInterceptor, multi: true, deps: [ZoumasFakerService] },
    { provide: HTTP_INTERCEPTORS, useFactory: createMpsMockInterceptor, multi: true, deps: [ZiikosFakerService] },
  ],
};
